export { Marker } from 'react-native-maps';
